module.exports = __webpack_public_path__ + "static/img/talentenspel_begeleiding_2.e2c8feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/talentenspel_begeleiding_2.jpg
// module id = KwkG
// module chunks = 0